import styled from "styled-components"
import {IconButton} from "@irati/ui/src/Button"

const IconWrapper = styled.div`
  position: relative;
  top: -40px;
  padding-left: 8px;
  cursor: pointer;
  ${IconButton} {
    ${(props) => (props.hide && `
      display: none;
    `)}
  }
`

export default IconWrapper
